import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-editable-label',
    templateUrl: './editable-label.component.html',
    styleUrls: ['./editable-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditableLabelComponent implements OnInit {
    @Input()
    set editable(i_editable) {
        this._editable = i_editable;
    }

    @Input('type')
    _type = 'text';

    @Input('style')
    _style: any;

    @Input()
    showIcon = true;

    @Input()
    set value(i_value: string) {
        this._value = i_value;
    }

    @Output()
    labelEdited: EventEmitter<any> = new EventEmitter();

    _value = '';
    _editable = false;
    _editing = false;


    constructor() {
      this._style = {
        label: {
          // color: '#cbdddd',
          // 'fontSize': '20px'
        },
        editIcon: {
          // color: 'green',
          // 'fontSize': '20px'
        },
        input: {
          // color: 'black',
          // 'fontSize': '20px'
        }

      };
    }

    ngOnInit() {
    }

    onEdit(value: boolean) {
        if (!this._editable)
            return;
        this._editing = value;
        if (this._editing)
            return;
        this.labelEdited.emit(this._value);
        if (this._type == 'password')
            this._value = '*********';
    }
}
